import React, { useState } from 'react'
import Switch from '@mui/material/Switch'
import { useTranslation } from 'react-i18next'
import { PAY_URL } from '../../helpers/config/config'
import { nanoid } from 'nanoid'

interface PlanInfo {
  quantity: string
  info: string
}

interface PlanOption {
  title: string
  plan: string
  info_main: string
  info?: PlanInfo[]
  priceM: string
  priceY: string
  active: boolean
  color: string
  urlM: string
  urlY: string
}

interface PlansCardsProps {
  cardsOptions: PlanOption[]
  selectPlan: (plan: string) => void
}

const PlansCards = ({ cardsOptions, selectPlan }: PlansCardsProps) => {
  const [checked, setChecked] = useState(false)
  const { t } = useTranslation()

  const handleClick = () => {
    setChecked(!checked)
  }

  const goToPay = (payUrlId: string) => {
    const email = sessionStorage.getItem('user_email')
    const uniqueId = nanoid()
    const url = `${PAY_URL}/${payUrlId}/null/${email}-${uniqueId}`
    window.open(url, '_blank')
  }

  return (
    <>
      <div className='container-swicth'>
        <span>{`${t('PAY_ANNUALY')}`}</span>
        <Switch checked={checked} onChange={handleClick} />
        <span>{`${t('PAY_MONTHLY')}`}</span>
      </div>
      <div className='container-cards'>
        {cardsOptions.map((option: PlanOption, index: number) => (
          <div className='container-card' key={index}>
            <div
              className={`plan-card card-plan-extra-style border-card-${option.color}`}
            >
              <label htmlFor={option.plan} className='plan-card-label'>
                <input
                  type='radio'
                  name='option'
                  id={option.plan}
                  value={option.plan}
                  onClick={() => selectPlan(option.plan)}
                />
                <div className='container-plan-content-title'>
                  <span className='plan-content-title'>{`${t(
                    option.title
                  )}`}</span>
                  <strong>
                    <span className={`color-${option.color}`}>{`${
                      option.active ? t('MOST_POPULAR') : ''
                    }`}</span>
                  </strong>
                </div>
                <div className='container-price'>
                  <span className={`price color-${option.color}`}>{`$${
                    checked ? option.priceM : option.priceY
                  }`}</span>
                  <div className='container-price-content'>
                    <span>{`${t('USER')}/`}</span>
                    <span>{`${t('MONTH')}`}</span>
                  </div>
                </div>
                <div
                  className='container-button-get-started'
                  onClick={() => selectPlan(option.plan)}
                >
                  <button
                    type='button'
                    className={`button-get-started-${option.color}`}
                    onClick={() =>
                      goToPay(checked ? option.urlM : option.urlY)
                    }
                  >
                    {`${t('GET_STARTED')}`}
                  </button>
                </div>
                <div className='container-card-main-title'>
                  <strong>
                    <span>{`${t(option.info_main)}`}</span>
                  </strong>
                </div>
                <div className='plan-card-content'>
                  <ul>
                    {option?.info?.map((opt: PlanInfo, optIndex: number) => (
                      <li className='list-items' key={optIndex}>
                        {`${t(opt.quantity)} ${t(opt.info)}`}
                      </li>
                    ))}
                  </ul>
                </div>
              </label>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default PlansCards
